<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <ListPanel :portal="portal" :primary-menu-link="primaryMenuLink"/>

      <FormPanel
          :initial="primaryMenuLink.attributes"
          headline="Edit Primary Menu Link"
          :errors="errors"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/PrimaryMenuLinks/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'
import ListPanel from '../../../../../../../components/Administration/PrimaryMenuLinkChildren/Panels/List'

export default {
  components: {LoadingContainer, FormPanel, ListPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      primaryMenuLink: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/primary-menu-links/' + this.$route.params.primaryMenuLinkId).then(response => {
        this.primaryMenuLink = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/primary-menu-links/' + this.$route.params.primaryMenuLinkId, data)
          .then(response => {
            notify.success('The primary menu link was saved')

            this.primaryMenuLink = response.data.data

            this.errors = {}
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
